import React, { useState, useEffect } from "react";
import { Modal, Input, Select, Button, message, Card, Divider } from "antd";
import { httpPlatform } from "../../services/api.platform";
import { http } from "../../services/http";

const { Option } = Select;

const UniversalEditModal = ({
  visible,
  onCancel,
  data,
  onSuccess,
  title = "Ma'lumotlarni tahrirlash",
  fields = [],
  apiEndpoint,
  showLimitButton = false,
  onLimitClick,
}) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [limitLoading, setLimitLoading] = useState(false);

  // Boshlang'ich ma'lumotlarni o'rnatish
  useEffect(() => {
    if (data && visible && fields.length > 0) {
      const initialData = {};
      fields.forEach((field) => {
        let value = data[field.key] || field.defaultValue || "";

        // Telefon raqami uchun formatlash
        if ((field.key === "phone1" || field.key === "phoneNum") && value) {
          value = formatPhoneNumber(value);
        }

        initialData[field.key] = value;
      });
      setFormData(initialData);
    }
  }, [data, visible, fields]);

  // Telefon raqamini formatlash
  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, "");
    if (!cleaned) return "";

    let formatted = cleaned;
    if (!cleaned.startsWith("998") && cleaned.length > 0) {
      formatted = "998" + cleaned;
    }

    if (formatted.length > 12) {
      formatted = formatted.substring(0, 12);
    }

    // Tor bo‘shliq
    const sp = "\u202F"; // narrow no-break space

    if (formatted.length >= 3) {
      let result = "+998";
      const number = formatted.substring(3);

      if (number.length > 0) {
        if (number.length <= 2) {
          result += sp + number;
        } else if (number.length <= 5) {
          result += sp + number.substring(0, 2) + sp + number.substring(2);
        } else if (number.length <= 7) {
          result +=
            sp +
            number.substring(0, 2) +
            sp +
            number.substring(2, 5) +
            sp +
            number.substring(5);
        } else {
          result +=
            sp +
            number.substring(0, 2) +
            sp +
            number.substring(2, 5) +
            sp +
            number.substring(5, 7) +
            sp +
            number.substring(7);
        }
      }
      return result;
    }

    return "+" + formatted;
  };

  const handleInputChange = (field, value) => {
    let formattedValue = value;

    // Telefon raqami uchun maxsus format
    if (field === "phone1" || field === "phoneNum") {
      formattedValue = formatPhoneNumber(value);
    }

    setFormData((prev) => ({
      ...prev,
      [field]: formattedValue,
    }));
  };

  const handleSave = async () => {
    // Validatsiya
    for (const field of fields) {
      if (field.required && !formData[field.key]?.toString().trim()) {
        message.error(`${field.label}ni kiriting`);
        return;
      }
    }

    try {
      setLoading(true);

      // API ga yuborish uchun ma'lumotlarni tayyorlash
      const dataToSend = { ...formData };

      // Telefon raqamni formatdan tozalash va "+" qo'shish
      if (dataToSend.phone1) {
        const cleanedPhone = dataToSend.phone1.replace(/\D/g, "");
        dataToSend.phone1 = "+" + cleanedPhone;
      }
      if (dataToSend.phoneNum) {
        const cleanedPhone = dataToSend.phoneNum.replace(/\D/g, "");
        dataToSend.phoneNum = "+" + cleanedPhone;
      }

      // API chaqiruvi
      await httpPlatform.patch(`${apiEndpoint}/${data.cardCode}`, dataToSend);

      message.success("Ma'lumotlar muvaffaqiyatli yangilandi");
      onSuccess();
      onCancel();
    } catch (error) {
      console.error("Xatolik:", error);
      message.error("Ma'lumotlarni saqlashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  const handleLimitClick = async () => {
    if (!data?.cardCode) {
      message.error("Hodim kodi topilmadi");
      return;
    }

    try {
      setLimitLoading(true);
      await http.patch(
        `api/businesspartners/employer-limit?cardCode=${data.cardCode}`,
      );

      message.success("Muvaffaqiyatli yuborildi");
    } catch (error) {
      console.error("Limit olishda xatolik:", error);
      message.error("Yuborishda xatolik");
    } finally {
      setLimitLoading(false);
    }
  };

  const renderField = (field) => {
    const { key, label, type, options, placeholder, maxLength, disabled } =
      field;

    const commonProps = {
      value: formData[key] || "",
      onChange: (e) => handleInputChange(key, e.target.value),
      placeholder,
      disabled,
      size: "large",
      style: {
        borderRadius: "8px",
        transition: "all 0.2s ease",
        border: "1px solid #d1d5db",
      },
      onFocus: (e) => {
        e.target.style.borderColor = "#0A4D68";
        e.target.style.boxShadow = "0 0 0 2px rgba(10, 77, 104, 0.1)";
      },
      onBlur: (e) => {
        e.target.style.borderColor = "#d1d5db";
        e.target.style.boxShadow = "none";
      },
    };

    switch (type) {
      case "select":
        return (
          <Select
            value={formData[key]}
            onChange={(value) => handleInputChange(key, value)}
            style={{ width: "100%", borderRadius: "8px" }}
            placeholder={placeholder}
            disabled={disabled}
            size="large"
          >
            {options?.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        );
      case "number":
        return <Input type="number" {...commonProps} maxLength={maxLength} />;
      case "phone":
        return (
          <div>
            <Input
              {...commonProps}
              placeholder={placeholder || "+998 XX XXX XX XX"}
              maxLength={17}
              style={{
                borderRadius: "8px",
                fontSize: "16px",
                fontFamily: "monospace",
                letterSpacing: "1px",
              }}
              onFocus={(e) => {
                if (!e.target.value) {
                  handleInputChange(key, "+998 ");
                }
                e.target.style.borderColor = "#0A4D68";
                e.target.style.boxShadow = "0 0 0 2px rgba(10, 77, 104, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
            <div
              style={{
                fontSize: "12px",
                color: "#6b7280",
                marginTop: "4px",
                fontStyle: "italic",
              }}
            >
              Masalan: +998 90 123 45 67
            </div>
          </div>
        );
      case "email":
        return (
          <Input
            type="email"
            {...commonProps}
            placeholder={placeholder || "example@email.com"}
            maxLength={maxLength}
          />
        );
      case "textarea":
        return (
          <Input.TextArea
            value={formData[key] || ""}
            onChange={(e) => handleInputChange(key, e.target.value)}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            rows={3}
            style={{ borderRadius: "8px", resize: "none" }}
          />
        );
      case "date":
        return (
          <Input
            type="date"
            value={formData[key] || ""}
            onChange={(e) => handleInputChange(key, e.target.value)}
            disabled={disabled}
            size="large"
            style={{ borderRadius: "8px" }}
          />
        );
      default:
        return <Input {...commonProps} maxLength={maxLength} />;
    }
  };

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={650}
      centered
      style={{ borderRadius: "12px" }}
      bodyStyle={{ padding: 0 }}
      maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
      transitionName="ant-zoom"
      maskTransitionName="ant-fade"
    >
      <Card
        style={{
          border: "none",
          borderRadius: "12px",
        }}
        bodyStyle={{ padding: "24px" }}
      >
        {/* Header */}
        <div style={{ marginBottom: "24px", textAlign: "center" }}>
          <h2
            style={{
              margin: 0,
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            {title}
          </h2>
          <Divider style={{ margin: "16px 0", backgroundColor: "#f0f0f0" }} />
        </div>

        {/* Form Fields */}
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {fields.map((field, index) => (
            <div key={field.key} style={{ marginBottom: "4px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#374151",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                {field.label}
                {field.required && (
                  <span style={{ color: "#ef4444", marginLeft: "4px" }}>*</span>
                )}
              </label>
              <div>{renderField(field)}</div>
            </div>
          ))}
        </div>

        {/* Footer Buttons */}
        <div
          style={{
            marginTop: "32px",
            display: "flex",
            justifyContent: showLimitButton ? "space-between" : "flex-end",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {showLimitButton && (
            <Button
              onClick={handleLimitClick}
              loading={limitLoading}
              size="large"
              style={{
                borderRadius: "8px",
                height: "44px",
                paddingLeft: "24px",
                paddingRight: "24px",
                fontWeight: "500",
                border: "1px solid #0A4D68",
                color: "#0A4D68",
                backgroundColor: "transparent",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                if (!limitLoading) {
                  e.target.style.backgroundColor = "#0A4D68";
                  e.target.style.color = "#fff";
                }
              }}
              onMouseLeave={(e) => {
                if (!limitLoading) {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#0A4D68";
                }
              }}
            >
              Limit olish
            </Button>
          )}
          <div
            style={{
              display: "flex",
              gap: "12px",
              marginLeft: showLimitButton ? "auto" : "0",
            }}
          >
            <Button
              onClick={onCancel}
              size="large"
              style={{
                borderRadius: "8px",
                height: "44px",
                paddingLeft: "24px",
                paddingRight: "24px",
                fontWeight: "500",
                border: "1px solid #d1d5db",
                color: "#374151",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = "#9ca3af";
                e.target.style.color = "#1f2937";
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.color = "#374151";
              }}
            >
              Bekor qilish
            </Button>
            <Button
              type="primary"
              onClick={handleSave}
              loading={loading}
              size="large"
              style={{
                backgroundColor: "#0A4D68",
                borderColor: "#0A4D68",
                color: "#fff",
                borderRadius: "8px",
                height: "44px",
                paddingLeft: "24px",
                paddingRight: "24px",
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(10, 77, 104, 0.2)",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  const btn = e.currentTarget;
                  btn.style.backgroundColor = "#083344";
                  btn.style.borderColor = "#083344";
                  btn.style.color = "#fff";
                  btn.style.boxShadow = "0 4px 8px rgba(10, 77, 104, 0.3)";
                  btn.style.transform = "translateY(-1px)";

                  const span = btn.querySelector("span");
                  if (span) {
                    span.style.backgroundColor = "#083344";
                    span.style.transition = "background-color 0.2s ease";
                  }
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  const btn = e.currentTarget;
                  btn.style.backgroundColor = "#0A4D68";
                  btn.style.borderColor = "#0A4D68";
                  btn.style.color = "#fff";
                  btn.style.boxShadow = "0 2px 4px rgba(10, 77, 104, 0.2)";
                  btn.style.transform = "translateY(0)";

                  const span = btn.querySelector("span");
                  if (span) {
                    span.style.backgroundColor = "#0A4D68";
                    span.style.transition = "background-color 0.2s ease";
                  }
                }
              }}
            >
              Saqlash
            </Button>
          </div>
        </div>
      </Card>
    </Modal>
  );
};

export default UniversalEditModal;
